import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "search-page-table",
  id: "searchPageTable"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "header-label" }
const _hoisted_5 = { key: 1 }

import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import SearchPageSearchResultsTableRow from "@/components/v2/search-page/SearchPageSearchResultsTableRow.vue";
import { TableHeader } from "@/models/table";
import {
  isActiveSort,
  getSortArrow,
  sort,
  sortBy,
  getSortArrowIcon,
} from "@/composables/tableUtils";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchResultsTable',
  props: {
    results: { default: () => [] },
    freezeHeaderRow: { type: Boolean, default: true },
    showHeaders: { type: Boolean, default: true },
    showRows: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();

const sortKey = ref<string>("");
const sortOrder = ref<number>(1);

const headers = ref<Array<TableHeader>>([
  {
    label: "Borrower",
    sortable: true,
    key: "borrowerName",
    sortProperty: "borrowerName",
    display: true,
    title: "Name sort by last name.",
  },
  {
    label: "Status",
    sortable: true,
    key: "certificationStatusTypeDescription",
    sortProperty: "certificationStatusTypeDescription",
    display: true,
  },
  {
    label: "Lender",
    sortable: true,
    key: "lenderName",
    sortProperty: "lenderName",
    display: true,
  },
  {
    label: "App ID",
    sortable: true,
    key: "referenceId",
    sortProperty: "referenceId",
    display: true,
  },
  {
    label: "Loan Amt",
    title: "Loan Amount",
    sortable: true,
    key: "loanAmountFormatted",
    sortProperty: "loanAmount",
    display: true,
  },
]);

const disbursementsTableHeaders = ref<Array<TableHeader>>([
  {
    label: "Disb. Date",
    name: "DisbursementDate",
    title: "Disbursement Date",
    sortable: true,
    key: "disbursementDateDisplay",
    sortProperty: "disbursementDateDisplay",
    display: true,
  },
  {
    label: "Method",
    sortable: true,
    key: "disbursementMethodTypeDescription",
    sortProperty: "disbursementMethodTypeDescription",
    display: true,
  },
  {
    label: "Borrower",
    sortable: true,
    key: "borrowerName",
    sortProperty: "borrowerName",
    display: true,
    title: "Name sort by last name.",
  },
  {
    label: "Status",
    sortable: true,
    key: "disbursementStatusTypeName",
    sortProperty: "disbursementStatusTypeName",
    display: true,
  },
  {
    label: "Lender",
    sortable: true,
    key: "lenderName",
    sortProperty: "lenderName",
    display: true,
  },
  {
    label: "App ID",
    sortable: true,
    key: "referenceId",
    sortProperty: "referenceId",
    display: true,
  },
  {
    label: "Disb. Amt",
    title: "Disbursement Amount",
    sortable: true,
    key: "disbursementAmountFormatted",
    sortProperty: "disbursementAmount",
    display: true,
  },
]);

const tableHeaders = computed<Array<TableHeader>>(() => {
  if (route.name === "Certifications") {
    return headers.value.filter((t: TableHeader) => t.display);
  } else if (route.name === "Disbursements") {
    return disbursementsTableHeaders.value.filter(
      (t: TableHeader) => t.display
    );
  } else {
    return [];
  }
});

function applySortBy(key: string) {
  const sortByResponse = sortBy(sortKey.value, sortOrder.value, key);

  sortKey.value = sortByResponse.sortKey;
  sortOrder.value = sortByResponse.sortOrder;

  router.push({
    query: {
      ...route.query,
      resultSortKey: sortKey.value,
      resultSortOrder: sortOrder.value.toString(),
    },
    hash: route.hash,
  });
}

function intializeSorting() {
  const querySortKey = route.query.resultSortKey as string;
  const querySortOrder = parseInt(route.query.resultSortOrder as string, 10);

  if (querySortKey) {
    sortKey.value = querySortKey;
  }

  if (
    !isNaN(querySortOrder) &&
    (querySortOrder === 1 || querySortOrder === -1)
  ) {
    sortOrder.value = querySortOrder;
  }
}

onMounted(async () => {
  intializeSorting();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-wrapper", { freezeHeaderRow: __props.freezeHeaderRow }]),
    id: "searchPageTable"
  }, [
    _createElementVNode("table", _hoisted_1, [
      (__props.showHeaders)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_2, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeaders.value, (header) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.key,
                  class: _normalizeClass(_unref(isActiveSort)(sortKey.value, header.key)),
                  onClick: ($event: any) => (applySortBy(header.key))
                }, [
                  _createElementVNode("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(header.label) + " ", 1),
                    (header.sortable)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(_unref(getSortArrowIcon)(sortKey.value, sortOrder.value, header.key))
                        }, _toDisplayString(_unref(getSortArrow)(sortKey.value, sortOrder.value, header.key)), 3))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_3))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.showRows)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.results, (result) => {
              return (_openBlock(), _createBlock(SearchPageSearchResultsTableRow, {
                key: `${result.referenceId}_${result.id}`,
                result: result,
                headers: tableHeaders.value
              }, null, 8, ["result", "headers"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})